namespace RioERP.Orders {
    export interface OrderTeacherShareCalculationRow {
        Id?: number;
        OrderId?: number;
        OrderProductsId?: number;
        TeacherId?: number;
        SharePercentage?: number;
        OrderProdutcsCost?: number;
        ShareAmount?: number;
        Qty?: number;
        SettelmentId?: number;
        ESettelementStatus?: Web.Enums.SettelementStatusType;
        TotalShare?: number;
        IsActive?: boolean;
        OrderCustomerId?: number;
        OrderOrderNumber?: string;
        OrderCustomerName?: string;
        OrderCustomerEmail1?: string;
        OrderCustomerEmail2?: string;
        OrderCustomerMobile1?: string;
        OrderCustomerMobile2?: string;
        OrderBillingAddress1?: string;
        OrderBillingAddress2?: string;
        OrderBillingCity?: string;
        OrderBillingStateId?: number;
        OrderBillingPincode?: number;
        OrderShippingToName?: string;
        OrderShippingAddress1?: string;
        OrderShippingAddress2?: string;
        OrderShippingCity?: string;
        OrderShippingStateId?: number;
        OrderShippingPincode?: number;
        OrderEOrderStatus?: number;
        OrderEShippingType?: number;
        OrderDiscountPer?: number;
        OrderOrderDate?: string;
        OrderESourceType?: number;
        OrderSourceName?: string;
        OrderEmailSendCount?: number;
        OrderIsEmailSent?: boolean;
        OrderEPaymentStatus?: number;
        OrderLastEmailSentDate?: string;
        OrderFranchiseeId?: number;
        OrderEOrderProcessBy?: number;
        OrderDiscountCoupon?: string;
        OrderDiscountAmount?: number;
        OrderGrossAmount?: number;
        OrderNetAmount?: number;
        OrderTaxableAmount?: number;
        OrderEShippingStatus?: number;
        OrderEInvoiceStatus?: number;
        OrderMailId?: number;
        OrderEPaymentType?: number;
        OrderGstin?: string;
        OrderExpectedShippingDate?: string;
        OrderEInvoiceTo?: number;
        OrderEFranchiseeDiscountType?: number;
        OrderEFranchiseeDiscount?: number;
        OrderFranchiseeDiscountValue?: number;
        OrderFranchiseeDiscountAmount?: number;
        OrderInvoiceCompanyId?: number;
        OrderShippingNote?: string;
        OrderSourceOrderNumber?: string;
        OrderIsActive?: boolean;
        OrderInsertUserId?: number;
        OrderInsertDate?: string;
        OrderUpdateUserId?: number;
        OrderUpdateDate?: string;
        OrderVendorId?: number;
        OrderProductsOrderId?: number;
        OrderProductsProductId?: number;
        OrderProductsQuantity?: number;
        OrderProductsCost?: number;
        OrderProductsGrossAmount?: number;
        OrderProductsDiscountAmt?: number;
        OrderProductsNetAmount?: number;
        OrderProductsTaxableAmount?: number;
        OrderProductsSerialKey?: string;
        OrderProductsHasPendrive?: boolean;
        OrderProductsHasBooks?: boolean;
        OrderProductsHasCourier?: boolean;
        OrderProductsDownloadUrl1?: string;
        OrderProductsDownloadUrl2?: string;
        OrderProductsIsActive?: boolean;
        OrderProductsInvoiceCompanyId?: number;
        OrderProductsFranchiseeDiscountAmount?: number;
        OrderProductsFranchiseeDiscountValue?: number;
        OrderProductsEFranchiseeDiscountType?: number;
        OrderProductsEOpens?: number;
        OrderProductsEWatchTime?: number;
        OrderProductsEValidity?: number;
        OrderProductsEValidityType?: number;
        OrderProductsValidTill?: string;
        OrderProductsTotalAllowedDuration?: number;
        OrderProductsAllowedDevices?: string;
        OrderProductsIsLive?: boolean;
        OrderProductsEAccessStatus?: number;
        OrderProductsIsTemplateSerialKey?: boolean;
        OrderProductsInsertUserId?: number;
        OrderProductsInsertDate?: string;
        OrderProductsUpdateUserId?: number;
        OrderProductsUpdateDate?: string;
        OrderProductsNote?: string;
        OrderProductsESerialkeyStatus?: number;
        TeacherName?: string;
        TeacherDescription?: string;
        TeacherEmail?: string;
        TeacherAlternateEmail?: string;
        TeacherMobile?: string;
        TeacherAlternateMobile?: string;
        TeacherAddress?: string;
        TeacherCity?: string;
        TeacherStateId?: number;
        TeacherUserId?: number;
        TeacherGstin?: string;
        TeacherPan?: string;
        TeacherGstCertificate?: string;
        TeacherBankName?: string;
        TeacherBankAccountType?: number;
        TeacherBankAccountName?: string;
        TeacherBankAccountNo?: string;
        TeacherBankIfscCode?: string;
        TeacherPincode?: number;
        TeacherIsActive?: boolean;
        TeacherInsertUserId?: number;
        TeacherInsertDate?: string;
        TeacherUpdateUserId?: number;
        TeacherUpdateDate?: string;
        InsertUserId?: number;
        InsertDate?: string;
        UpdateUserId?: number;
        UpdateDate?: string;
    }

    export namespace OrderTeacherShareCalculationRow {
        export const idProperty = 'Id';
        export const localTextPrefix = 'Orders.OrderTeacherShareCalculation';
        export const deletePermission = 'Orders:OrdersManagement:Modify|Orders:TeachersOrdersManagement:Modify';
        export const insertPermission = 'Orders:OrdersManagement:Modify|Orders:TeachersOrdersManagement:Modify';
        export const readPermission = 'Orders:OrdersManagement:View|Orders:TeachersOrdersManagement:View';
        export const updatePermission = 'Orders:OrdersManagement:Modify|Orders:TeachersOrdersManagement:Modify';

        export declare const enum Fields {
            Id = "Id",
            OrderId = "OrderId",
            OrderProductsId = "OrderProductsId",
            TeacherId = "TeacherId",
            SharePercentage = "SharePercentage",
            OrderProdutcsCost = "OrderProdutcsCost",
            ShareAmount = "ShareAmount",
            Qty = "Qty",
            SettelmentId = "SettelmentId",
            ESettelementStatus = "ESettelementStatus",
            TotalShare = "TotalShare",
            IsActive = "IsActive",
            OrderCustomerId = "OrderCustomerId",
            OrderOrderNumber = "OrderOrderNumber",
            OrderCustomerName = "OrderCustomerName",
            OrderCustomerEmail1 = "OrderCustomerEmail1",
            OrderCustomerEmail2 = "OrderCustomerEmail2",
            OrderCustomerMobile1 = "OrderCustomerMobile1",
            OrderCustomerMobile2 = "OrderCustomerMobile2",
            OrderBillingAddress1 = "OrderBillingAddress1",
            OrderBillingAddress2 = "OrderBillingAddress2",
            OrderBillingCity = "OrderBillingCity",
            OrderBillingStateId = "OrderBillingStateId",
            OrderBillingPincode = "OrderBillingPincode",
            OrderShippingToName = "OrderShippingToName",
            OrderShippingAddress1 = "OrderShippingAddress1",
            OrderShippingAddress2 = "OrderShippingAddress2",
            OrderShippingCity = "OrderShippingCity",
            OrderShippingStateId = "OrderShippingStateId",
            OrderShippingPincode = "OrderShippingPincode",
            OrderEOrderStatus = "OrderEOrderStatus",
            OrderEShippingType = "OrderEShippingType",
            OrderDiscountPer = "OrderDiscountPer",
            OrderOrderDate = "OrderOrderDate",
            OrderESourceType = "OrderESourceType",
            OrderSourceName = "OrderSourceName",
            OrderEmailSendCount = "OrderEmailSendCount",
            OrderIsEmailSent = "OrderIsEmailSent",
            OrderEPaymentStatus = "OrderEPaymentStatus",
            OrderLastEmailSentDate = "OrderLastEmailSentDate",
            OrderFranchiseeId = "OrderFranchiseeId",
            OrderEOrderProcessBy = "OrderEOrderProcessBy",
            OrderDiscountCoupon = "OrderDiscountCoupon",
            OrderDiscountAmount = "OrderDiscountAmount",
            OrderGrossAmount = "OrderGrossAmount",
            OrderNetAmount = "OrderNetAmount",
            OrderTaxableAmount = "OrderTaxableAmount",
            OrderEShippingStatus = "OrderEShippingStatus",
            OrderEInvoiceStatus = "OrderEInvoiceStatus",
            OrderMailId = "OrderMailId",
            OrderEPaymentType = "OrderEPaymentType",
            OrderGstin = "OrderGstin",
            OrderExpectedShippingDate = "OrderExpectedShippingDate",
            OrderEInvoiceTo = "OrderEInvoiceTo",
            OrderEFranchiseeDiscountType = "OrderEFranchiseeDiscountType",
            OrderEFranchiseeDiscount = "OrderEFranchiseeDiscount",
            OrderFranchiseeDiscountValue = "OrderFranchiseeDiscountValue",
            OrderFranchiseeDiscountAmount = "OrderFranchiseeDiscountAmount",
            OrderInvoiceCompanyId = "OrderInvoiceCompanyId",
            OrderShippingNote = "OrderShippingNote",
            OrderSourceOrderNumber = "OrderSourceOrderNumber",
            OrderIsActive = "OrderIsActive",
            OrderInsertUserId = "OrderInsertUserId",
            OrderInsertDate = "OrderInsertDate",
            OrderUpdateUserId = "OrderUpdateUserId",
            OrderUpdateDate = "OrderUpdateDate",
            OrderVendorId = "OrderVendorId",
            OrderProductsOrderId = "OrderProductsOrderId",
            OrderProductsProductId = "OrderProductsProductId",
            OrderProductsQuantity = "OrderProductsQuantity",
            OrderProductsCost = "OrderProductsCost",
            OrderProductsGrossAmount = "OrderProductsGrossAmount",
            OrderProductsDiscountAmt = "OrderProductsDiscountAmt",
            OrderProductsNetAmount = "OrderProductsNetAmount",
            OrderProductsTaxableAmount = "OrderProductsTaxableAmount",
            OrderProductsSerialKey = "OrderProductsSerialKey",
            OrderProductsHasPendrive = "OrderProductsHasPendrive",
            OrderProductsHasBooks = "OrderProductsHasBooks",
            OrderProductsHasCourier = "OrderProductsHasCourier",
            OrderProductsDownloadUrl1 = "OrderProductsDownloadUrl1",
            OrderProductsDownloadUrl2 = "OrderProductsDownloadUrl2",
            OrderProductsIsActive = "OrderProductsIsActive",
            OrderProductsInvoiceCompanyId = "OrderProductsInvoiceCompanyId",
            OrderProductsFranchiseeDiscountAmount = "OrderProductsFranchiseeDiscountAmount",
            OrderProductsFranchiseeDiscountValue = "OrderProductsFranchiseeDiscountValue",
            OrderProductsEFranchiseeDiscountType = "OrderProductsEFranchiseeDiscountType",
            OrderProductsEOpens = "OrderProductsEOpens",
            OrderProductsEWatchTime = "OrderProductsEWatchTime",
            OrderProductsEValidity = "OrderProductsEValidity",
            OrderProductsEValidityType = "OrderProductsEValidityType",
            OrderProductsValidTill = "OrderProductsValidTill",
            OrderProductsTotalAllowedDuration = "OrderProductsTotalAllowedDuration",
            OrderProductsAllowedDevices = "OrderProductsAllowedDevices",
            OrderProductsIsLive = "OrderProductsIsLive",
            OrderProductsEAccessStatus = "OrderProductsEAccessStatus",
            OrderProductsIsTemplateSerialKey = "OrderProductsIsTemplateSerialKey",
            OrderProductsInsertUserId = "OrderProductsInsertUserId",
            OrderProductsInsertDate = "OrderProductsInsertDate",
            OrderProductsUpdateUserId = "OrderProductsUpdateUserId",
            OrderProductsUpdateDate = "OrderProductsUpdateDate",
            OrderProductsNote = "OrderProductsNote",
            OrderProductsESerialkeyStatus = "OrderProductsESerialkeyStatus",
            TeacherName = "TeacherName",
            TeacherDescription = "TeacherDescription",
            TeacherEmail = "TeacherEmail",
            TeacherAlternateEmail = "TeacherAlternateEmail",
            TeacherMobile = "TeacherMobile",
            TeacherAlternateMobile = "TeacherAlternateMobile",
            TeacherAddress = "TeacherAddress",
            TeacherCity = "TeacherCity",
            TeacherStateId = "TeacherStateId",
            TeacherUserId = "TeacherUserId",
            TeacherGstin = "TeacherGstin",
            TeacherPan = "TeacherPan",
            TeacherGstCertificate = "TeacherGstCertificate",
            TeacherBankName = "TeacherBankName",
            TeacherBankAccountType = "TeacherBankAccountType",
            TeacherBankAccountName = "TeacherBankAccountName",
            TeacherBankAccountNo = "TeacherBankAccountNo",
            TeacherBankIfscCode = "TeacherBankIfscCode",
            TeacherPincode = "TeacherPincode",
            TeacherIsActive = "TeacherIsActive",
            TeacherInsertUserId = "TeacherInsertUserId",
            TeacherInsertDate = "TeacherInsertDate",
            TeacherUpdateUserId = "TeacherUpdateUserId",
            TeacherUpdateDate = "TeacherUpdateDate",
            InsertUserId = "InsertUserId",
            InsertDate = "InsertDate",
            UpdateUserId = "UpdateUserId",
            UpdateDate = "UpdateDate"
        }
    }
}
